import { isEmpty } from 'lodash';
import { MedicationListReminderServiceEnumComponent } from '../../../../../enumComponent/MedicationListReminderServiceEnumComponent/MedicationListReminderServiceEnumComponent';
import { MedicationListReviewEnumComponent } from '../../../../../enumComponent/MedicationListReviewEnumComponent/MedicationListReviewEnumComponent';
import {
  ClinicEvent,
  Medication,
  MedicationReminderEnum,
  Nullable,
  UcMedicationManagement,
  VisitTypeEnum
} from '../../../../../uc-api-sdk';
import DisplayOrEmptyComponent from '../../../../../uiComponent/DisplayComponent/DisplayOrEmptyComponent';
import { TextComponent } from '../../../../../uiComponent/TextComponent/TextComponent';
import { PrintCarePlanSimpleItemComponent } from '../PrintCarePlanSimpleItemComponent/PrintCarePlanSimpleItemComponent';
import { PrintCarePlanMedicationItemComponent } from './PrintCarePlanMedicationItemComponent';

export interface PrintCarePlanMedicationComponentProps {
  visit?: Nullable<ClinicEvent>;
  medication?: Nullable<UcMedicationManagement>;
  medicationList?: Nullable<Medication[]>;
}

export const PrintCarePlanMedicationComponent = ({
  visit,
  medication,
  medicationList = [],
}: PrintCarePlanMedicationComponentProps) => {
  if (isEmpty(medication)) {
    return <div>No Medications are available</div>;
  }
  if (visit?.visitType === VisitTypeEnum.INITIAL) {
    return (
      <>
        <div className="page-break" />
        <TextComponent className="pop-text">
          Obtain Patient Consent for Medication Reminders
        </TextComponent>
        <MedicationListReminderServiceEnumComponent
          value={medication.medicationReminder as MedicationReminderEnum}
        />
      </>
    );
  }
  return (
    <>
      <div className="page-break" />
      <TextComponent className="pop-text bold">
        Medication
      </TextComponent>
      <PrintCarePlanSimpleItemComponent
        label="Medication Review:"
        content={(
          <MedicationListReviewEnumComponent
            value={medication?.medicationCompliance}
          />
        )}
      />
      <PrintCarePlanSimpleItemComponent
        label="Note:"
        content={<DisplayOrEmptyComponent value={medication?.note} />}
      />
      <PrintCarePlanSimpleItemComponent
        label="Medication Reminder Service:"
        content={(
          <MedicationListReminderServiceEnumComponent
            value={medication?.medicationReminder as MedicationReminderEnum}
          />
        )}
      />
      {
        !!medicationList?.length && (
          <>
            <TextComponent
              className="mt12"
              size="medium"
              bold
            >
              Prescribed Medication
            </TextComponent>
            <ul>
              {
                medicationList.map((medicationItem) => (
                  <li key={medicationItem?.id}>
                    <PrintCarePlanMedicationItemComponent
                      medication={medicationItem}
                    />
                  </li>
                ))
              }
            </ul>
          </>
        )
      }
    </>
  );
};
